import axiosInstance from '@/plugins/axios';
import { uploadSizeQueryParams } from '@/utils/uploadImageSizePresets.js';

const BASE = '/api/games';

export const actions = {
    async fetchList(params = {}) {
        this.listLoading = true;
        try {
            const { data } = await axiosInstance.get(BASE, {
                params: { include: 'cover,assets', ...params },
            });
            this.list = data.data ?? data ?? [];
            return this.list;
        } catch (error) {
            console.error('Error fetching games:', error);
            throw error;
        } finally {
            this.listLoading = false;
        }
    },

    async fetchOne(id) {
        try {
            const { data } = await axiosInstance.get(`${BASE}/${id}`, {
                params: { include: 'cover,assets' },
            });
            const item = data.data ?? data;
            const idx = this.list.findIndex((x) => Number(x.id) === Number(id));
            if (idx >= 0) this.list[idx] = item;
            else this.list.push(item);
            return item;
        } catch (error) {
            console.error('Error fetching game:', error);
            throw error;
        }
    },

    async create(payload) {
        try {
            const { data } = await axiosInstance.post(BASE, payload);
            const item = data.data ?? data;
            this.list.push(item);
            return item;
        } catch (error) {
            console.error('Error creating game:', error);
            throw error;
        }
    },

    async duplicateGame(id, payload = {}) {
        try {
            const body = {};
            if (payload.name != null && String(payload.name).trim()) body.name = String(payload.name).trim();
            const { data } = await axiosInstance.post(`${BASE}/${id}/duplicate`, body);
            return data?.data ?? data;
        } catch (error) {
            console.error('Error duplicating game:', error);
            throw error;
        }
    },

    async update({ id, ...payload }) {
        try {
            const { data } = await axiosInstance.put(`${BASE}/${id}`, payload);
            const item = data.data ?? data;
            const idx = this.list.findIndex((x) => Number(x.id) === Number(id));
            if (idx >= 0) this.list[idx] = item;
            return item;
        } catch (error) {
            console.error('Error updating game:', error);
            throw error;
        }
    },

    async delete(id) {
        try {
            await axiosInstance.delete(`${BASE}/${id}`);
            this.list = this.list.filter((x) => Number(x.id) !== Number(id));
        } catch (error) {
            console.error('Error deleting game:', error);
            throw error;
        }
    },

    async uploadCover(id, file, size = null) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('media_collection', 'cover');
        await axiosInstance.post(`${BASE}/${id}/files`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params: uploadSizeQueryParams(size),
        });
    },

    async uploadAssets(id, files, clear = true, size = null) {
        const formData = new FormData();
        if (Array.isArray(files)) {
            files.forEach((f) => formData.append('files[]', f));
        } else {
            formData.append('file', files);
        }
        formData.append('media_collection', 'assets');
        if (clear) formData.append('clear', '1');
        await axiosInstance.post(`${BASE}/${id}/files`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params: uploadSizeQueryParams(size),
        });
    },

    async deleteGameFile(gameId, mediaId) {
        await axiosInstance.delete(`${BASE}/${gameId}/files/${mediaId}`);
    },

    async attachContentFeed(id, contentFeedId) {
        const { data } = await axiosInstance.put(`${BASE}/${id}/content-feeds/${contentFeedId}/attach`, {
            model_type: 'Laraplate\\Entities\\Game\\Models\\Game',
        });
        return data?.data ?? data;
    },
};
